import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";

const Inventory = Loadable(
  lazy(() =>
    import("./Inventory").then(({ Inventory }) => ({
      default: Inventory,
    }))
  )
);

export const inventoryRoutes = [
  {
    path: "/inventory",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.BOOKING]}>
        <Inventory />
      </AuthorizedRoute>
    ),
  },
];
